
import { Component, ChangeDetectionStrategy } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { NgbActiveModal, NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";

@Component({
    selector: 'st-payment-success-modal',
    templateUrl: `./successModal.html`,
    styleUrls: ['./successModal.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [FormsModule, NgbModule, NgxSkeletonLoaderModule]
})
export class PaymentSuccessModal{

    constructor(
        public activeModal: NgbActiveModal
    ){
        
    }
}